import axios, { AxiosInstance } from 'axios';
import { store } from '@/stores/dataStore/reduxStore/store';
import Random from '@/utilities/random';

export type TypeOptions = {
    isBasicAuth?: boolean,
    clientId?: string,
}

export const isSuccessStatusCode = (s: string | number) => {
    // May be string or number
    const statusType = typeof s;
    return (statusType === 'number' && s === 0) || (statusType === 'string' && s.toString().toUpperCase() === 'OK');
};

const createError = (statusCode: number, ec?: string, em?: string, tracerId?: string) => {
    return { statusCode, ec, em, tracerId };
};

const detectOSFromUserAgent = () => {
    const userAgent = navigator.userAgent;

    if (/Windows/i.test(userAgent)) return "Windows";
    if (/Macintosh|Mac OS X/i.test(userAgent)) return "macOS";
    if (/Android/i.test(userAgent)) return "Android";
    if (/iPhone|iPad|iPod/i.test(userAgent)) return "iOS";
    if (/Linux/i.test(userAgent)) return "Linux";

    return "";
}

class axiosBase {
    url: string;
    options: {};
    createInstance: () => AxiosInstance;
    constructor(url: string, options: TypeOptions) {
        this.url = url
        this.options = options;
        this.createInstance = () => {
            const instance: AxiosInstance = axios.create({
                baseURL: this.url,
                withCredentials: true,
                timeout: 2 * 60 * 1000,
            });

            instance.interceptors.request.use((request) => {
                if (request.baseURL) {
                    try {
                        const unixtiem = new Date().getTime();
                        const trackLogId = Random.randomRequestIdToServer() + "_" + unixtiem;
                        const { app } = store.getState()
                        const token = app.token ?? {}
                        const { access_token } = token
                        const userAgent = navigator.userAgent || '';
                        const platform = detectOSFromUserAgent();
                        request.headers.set('track_log_id', trackLogId);
                        request.headers.set('x-via', 'O');
                        request.headers.set('x-device', userAgent)
                        request.headers.set('x-devicetype', platform)
                        request.headers.set('x-lang', app?.language ?? 'vi');

                        if (access_token) {
                            request.headers.Authorization = `Bearer ${access_token}`;
                        }

                        if (options?.isBasicAuth === true) {
                            const basic = `${options?.clientId}`
                            request.headers.Authorization = `Basic ${btoa(basic)}`;
                        }

                        if (request.method === 'post' && typeof request.data === 'string') {
                            request.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                        }
                    } catch (error) {
                        console.error('Axios::Error', error)
                        return Promise.reject(error);
                    }
                }
                return request;
            });

            // type TResponseType = {
            //     s: string,
            //     ec: number,
            //     em: string,
            //     d: [] | {}
            // }

            instance.interceptors.response.use(
                (response: any) => {
                    // Thrown error for request with OK status code
                    // const { data, headers, status } = response;
                    const { data, headers, status } = response;
                    const { track_log_id } = headers

                    // console.log(response);
                    if (isSuccessStatusCode(data?.s) && (data?.ec === 0 || data?.ec === "0") && Object.hasOwn(data, 'd')) {
                        return data?.d
                    }

                    if (Object.hasOwn(data, 's') && !isSuccessStatusCode(data?.s) && Object.hasOwn(data, 'ec') && Object.hasOwn(data, 'em')) {
                        return Promise.reject(createError(status, data?.ec, data?.em, track_log_id));
                    }

                    return response.data;
                },
                async (error) => {
                    const { response } = error;
                    console.log('ha_check_error', error);
                    if (response == null) {
                        return Promise.reject(error);
                    }

                    const { data, status } = response;
                    if (status && status == 550) {
                        return Promise.reject(createError(status));
                    }

                    if (data.hasOwnProperty('s') && data.hasOwnProperty('em')) {
                        return Promise.reject(createError(response.status, data['em']));
                    }

                    if (data.hasOwnProperty('ec') && data.hasOwnProperty('em')) {
                        return Promise.reject(createError(response.status, data['ec'], data['em']));
                    }
                    return Promise.reject(createError(response.status));
                }
            );
            return instance
        };
    }
}

export default axiosBase;